export const fonts = {
  heading: `'Jost', sans-serif`,
  body: `'Jost', sans-serif`,
};

export const fontSizes = {
  xs: '0.625rem', // 10px
  s: '0.75rem', // 12px
  m: '0.875rem', // 14px
  l: '1rem', // 16px
  xl: '1.125rem', // 18px
  hs: '1.25rem', // 20px
  hmd: '1.375rem', // 22px
  hm: '1.5rem', // 24px
  hl: '1.75rem', // 28px
  hxl: '1.875rem', // 30px
  h2xl: '3rem', // 48px
};
